import Api from '@/axios'

export default {
  listDataTabl (url, filter) {
    return Api().get(url, {
      params: filter
    })
  },
  addImage (payload, config) {
    return Api().post('new-media', payload, config)
  },
  removeImage (id, type) {
    return Api().get(`remove-media/${id}`)
  },
  removeRow (url, rowId, method = 'delete', additionalRoute = '') {
    const api = rowId ? url + '/' + rowId + additionalRoute : url
    return Api()[method](`${api}`)
  },
  changeStatus (payload, key= 'service') {
    return Api().post(`${key}/${payload?.activity_id}/status/change`)
  },
  changeSort (payload) {
    return Api().post('update-sort', payload)
  },
  sort (payload) {
    return Api().post('update-sort/new', payload)
  },
  getListCountries (payload) {
    return Api().post('countries', payload)
  },
  getAllServices (params) {
    return Api().get('services', {
      params: params
    })
  }
}
